var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirefoxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 140,
    viewBox: "0 0 136 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.048 46.9542C127.163 39.8632 121.311 32.2069 116.729 29.7867C119.997 36.2531 122.266 43.1978 123.453 50.3737L123.465 50.4874C115.958 31.3687 103.228 23.6599 92.8319 6.87393C92.2949 6.01819 91.7735 5.15237 91.2678 4.27693C91.0072 3.81965 90.7632 3.35267 90.5364 2.87693C90.1052 2.0239 89.7729 1.12239 89.5462 0.19068C89.5465 0.147687 89.5313 0.106083 89.5035 0.0738066C89.4757 0.0415298 89.4372 0.0208387 89.3955 0.0156805C89.3545 0.00421329 89.3113 0.00421329 89.2704 0.0156805C89.2618 0.0156805 89.2481 0.0314305 89.2379 0.0349305C89.2276 0.0384305 89.2053 0.0541805 89.1899 0.0611805L89.2156 0.0156805C72.539 9.99068 66.8808 28.4567 66.36 37.6932C59.7001 38.1608 53.3328 40.6679 48.0885 44.8874C47.5414 44.414 46.9695 43.9712 46.3755 43.5609C44.8627 38.1516 44.7982 32.4267 46.1887 26.9832C40.0645 30.014 34.6226 34.3105 30.2076 39.6007H30.1768C27.5455 36.1934 27.7306 24.9584 27.8813 22.6117C27.1029 22.9313 26.3598 23.3343 25.6646 23.8139C23.3418 25.5075 21.1703 27.4078 19.1755 29.4927C16.9025 31.847 14.8264 34.3916 12.9691 37.0999V37.1104V37.0982C8.70062 43.2802 5.67306 50.2646 4.06125 57.6484L3.97217 58.0964C3.72728 59.5036 3.50968 60.9155 3.31949 62.3314C3.31949 62.3822 3.30921 62.4294 3.30408 62.4802C2.7229 65.566 2.36277 68.6911 2.22656 71.8304V72.1804C2.24112 89.1629 8.49126 105.522 19.7417 118.025C30.9922 130.527 46.4244 138.263 62.9885 139.705C79.5525 141.146 96.0431 136.187 109.201 125.808C122.359 115.429 131.228 100.385 134.053 83.6499C134.164 82.7749 134.255 81.9087 134.355 81.0249C135.722 69.4788 134.242 57.7667 130.048 46.9542ZM53.5258 100.046C53.8358 100.198 54.127 100.362 54.4457 100.508L54.4919 100.537C54.1699 100.38 53.8478 100.216 53.5258 100.046ZM123.47 50.5032V50.4384L123.482 50.5102L123.47 50.5032Z",
    fill: "url(#paint0_linear_2092_5807)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.048 46.9544C127.163 39.8634 121.311 32.2071 116.729 29.7869C119.997 36.2533 122.266 43.198 123.453 50.3739V50.4386L123.465 50.5104C128.582 65.4702 127.842 81.8715 121.399 96.2869C113.789 112.966 95.3706 130.062 66.5399 129.231C35.3879 128.329 7.95331 104.715 2.82442 73.7854C1.8908 68.9081 2.82442 66.4354 3.2938 62.4716C2.6535 65.5505 2.29621 68.6838 2.22656 71.8306V72.1806C2.24112 89.1631 8.49126 105.522 19.7417 118.025C30.9922 130.527 46.4244 138.264 62.9885 139.705C79.5525 141.146 96.0431 136.187 109.201 125.808C122.359 115.429 131.228 100.385 134.053 83.6501C134.164 82.7751 134.255 81.9089 134.355 81.0251C135.722 69.479 134.242 57.7669 130.048 46.9544Z",
    fill: "url(#paint1_radial_2092_5807)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.048 46.9544C127.163 39.8634 121.311 32.2071 116.729 29.7869C119.997 36.2533 122.266 43.198 123.453 50.3739V50.4386L123.465 50.5104C128.582 65.4702 127.842 81.8715 121.399 96.2869C113.789 112.966 95.3706 130.062 66.5399 129.231C35.3879 128.329 7.95331 104.715 2.82442 73.7854C1.8908 68.9081 2.82442 66.4354 3.2938 62.4716C2.6535 65.5505 2.29621 68.6838 2.22656 71.8306V72.1806C2.24112 89.1631 8.49126 105.522 19.7417 118.025C30.9922 130.527 46.4244 138.264 62.9885 139.705C79.5525 141.146 96.0431 136.187 109.201 125.808C122.359 115.429 131.228 100.385 134.053 83.6501C134.164 82.7751 134.255 81.9089 134.355 81.0251C135.722 69.479 134.242 57.7669 130.048 46.9544Z",
    fill: "url(#paint2_radial_2092_5807)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7847 54.9274C97.9286 55.0306 98.0622 55.1339 98.1975 55.2371C96.5298 52.2161 94.4537 49.4501 92.0305 47.0209C71.395 25.9369 86.6224 1.30562 89.1903 0.0543691L89.216 0.0158691C72.5394 9.99087 66.8811 28.4569 66.3604 37.6934C67.1347 37.6391 67.9021 37.5726 68.6935 37.5726C74.6108 37.5837 80.4196 39.1953 85.5293 42.2436C90.6391 45.2919 94.8675 49.6682 97.7847 54.9274Z",
    fill: "url(#paint3_radial_2092_5807)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7364 59.1378C68.6268 60.8248 62.7921 66.6435 60.7519 66.6435C41.8723 66.6435 38.8076 78.3108 38.8076 78.3108C39.6436 88.1353 46.3451 96.2273 54.4461 100.508C54.8161 100.704 55.1913 100.881 55.5665 101.054C56.2163 101.348 56.8661 101.62 57.5159 101.869C60.2961 102.874 63.2081 103.448 66.1549 103.572C99.246 105.158 105.656 63.147 81.7762 50.9565C87.4097 50.2077 93.1146 51.6227 97.7847 54.9273C94.8676 49.6681 90.6391 45.2918 85.5294 42.2435C80.4196 39.1952 74.6108 37.5836 68.6936 37.5725C67.9056 37.5725 67.1347 37.639 66.3604 37.6933C59.7006 38.1609 53.3333 40.668 48.089 44.8875C49.1014 45.7625 50.244 46.9315 52.6508 49.3553C57.1562 53.8895 68.7107 58.5865 68.7364 59.1378Z",
    fill: "url(#paint4_radial_2092_5807)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7364 59.1378C68.6268 60.8248 62.7921 66.6435 60.7519 66.6435C41.8723 66.6435 38.8076 78.3108 38.8076 78.3108C39.6436 88.1353 46.3451 96.2273 54.4461 100.508C54.8161 100.704 55.1913 100.881 55.5665 101.054C56.2163 101.348 56.8661 101.62 57.5159 101.869C60.2961 102.874 63.2081 103.448 66.1549 103.572C99.246 105.158 105.656 63.147 81.7762 50.9565C87.4097 50.2077 93.1146 51.6227 97.7847 54.9273C94.8676 49.6681 90.6391 45.2918 85.5294 42.2435C80.4196 39.1952 74.6108 37.5836 68.6936 37.5725C67.9056 37.5725 67.1347 37.639 66.3604 37.6933C59.7006 38.1609 53.3333 40.668 48.089 44.8875C49.1014 45.7625 50.244 46.9315 52.6508 49.3553C57.1562 53.8895 68.7107 58.5865 68.7364 59.1378Z",
    fill: "url(#paint5_radial_2092_5807)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9937 42.6316C45.5316 42.9816 45.9753 43.2861 46.3641 43.5609C44.8513 38.1515 44.7868 32.4266 46.1774 26.9832C40.0531 30.014 34.6113 34.3105 30.1963 39.6006C30.5201 39.5919 40.1509 39.4151 44.9937 42.6316Z",
    fill: "url(#paint6_radial_2092_5807)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8338 73.7852C7.95756 104.715 35.3973 128.329 66.5492 129.23C95.38 130.063 113.799 112.966 121.408 96.2867C127.851 81.8713 128.592 65.47 123.474 50.5102V50.4454C123.474 50.3947 123.464 50.3649 123.474 50.3807L123.486 50.4944C125.842 66.2042 118.02 81.4239 105.792 91.7157L105.754 91.8032C81.9291 111.625 59.1283 103.763 54.5133 100.553C54.1913 100.396 53.8692 100.232 53.5471 100.061C39.656 93.2784 33.9172 80.3494 35.1472 69.2614C31.8497 69.3111 28.6089 68.3829 25.8175 66.5891C23.026 64.7953 20.8036 62.2131 19.4196 59.1552C23.0661 56.8731 27.2238 55.5829 31.4967 55.4077C35.7696 55.2325 40.0152 56.178 43.829 58.1542C51.6917 61.8006 60.6388 62.1598 68.7574 59.1552C68.7317 58.6039 57.1771 53.9052 52.6718 49.3727C50.2649 46.9489 49.1223 45.7817 48.1099 44.9049C47.5628 44.4315 46.9909 43.9886 46.3968 43.5784C46.0028 43.3037 45.5592 43.0062 45.0264 42.6492C40.1836 39.4327 30.5528 39.6094 30.2342 39.6182H30.2033C27.5721 36.2109 27.7571 24.9759 27.9078 22.6292C27.1294 22.9487 26.3864 23.3517 25.6911 23.8314C23.3683 25.525 21.1968 27.4253 19.2021 29.5102C16.9209 31.8578 14.8362 34.3966 12.97 37.0999V37.1104V37.0982C8.70144 43.2801 5.67388 50.2646 4.06207 57.6484C4.02952 57.7867 1.67064 68.3217 2.8338 73.7852Z",
    fill: "url(#paint7_radial_2092_5807)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0344 47.0207C94.4582 49.4526 96.5343 52.2216 98.2014 55.2457C98.5662 55.5274 98.9071 55.8074 99.1966 56.0787C114.249 70.2537 106.362 90.2912 105.775 91.7174C118.003 81.4257 125.818 66.2059 123.469 50.4962C115.959 31.3687 103.229 23.6599 92.8326 6.87393C92.2957 6.01819 91.7742 5.15237 91.2686 4.27693C91.0079 3.81965 90.764 3.35267 90.5371 2.87693C90.106 2.0239 89.7737 1.12239 89.547 0.19068C89.5473 0.147687 89.5321 0.106083 89.5043 0.0738066C89.4765 0.0415298 89.438 0.0208387 89.3962 0.0156805C89.3553 0.00421329 89.3121 0.00421329 89.2712 0.0156805C89.2626 0.0156805 89.2489 0.0314305 89.2386 0.0349305C89.2284 0.0384305 89.2061 0.0541805 89.1907 0.0611805C86.6228 1.30543 71.3954 25.9367 92.0344 47.0207Z",
    fill: "url(#paint8_radial_2092_5807)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1862 56.07C98.8673 55.7768 98.5351 55.4988 98.1909 55.237C98.0556 55.1338 97.922 55.0305 97.7781 54.9273C93.108 51.6228 87.403 50.2077 81.7696 50.9565C105.65 63.154 99.2427 105.158 66.1482 103.572C63.2015 103.448 60.2895 102.874 57.5093 101.869C56.8594 101.621 56.2096 101.349 55.5598 101.054C55.1846 100.879 54.8095 100.704 54.4395 100.508L54.4857 100.538C59.1007 103.756 81.8946 111.619 105.727 91.7875L105.764 91.7C106.359 90.2825 114.246 70.2398 99.1862 56.07Z",
    fill: "url(#paint9_radial_2092_5807)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8074 78.3107C38.8074 78.3107 41.872 66.6434 60.7516 66.6434C62.7919 66.6434 68.6317 60.8247 68.7362 59.1377C60.6176 62.1424 51.6705 61.7831 43.8078 58.1367C39.994 56.1605 35.7484 55.215 31.4755 55.3902C27.2026 55.5654 23.0449 56.8556 19.3984 59.1377C20.7824 62.1956 23.0048 64.7779 25.7963 66.5716C28.5878 68.3654 31.8286 69.2936 35.126 69.2439C33.896 80.3337 39.6348 93.2627 53.526 100.044C53.836 100.196 54.1272 100.361 54.4459 100.506C46.338 96.2272 39.6433 88.1352 38.8074 78.3107Z",
    fill: "url(#paint10_radial_2092_5807)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.048 46.9542C127.163 39.8632 121.311 32.2069 116.729 29.7867C119.997 36.2531 122.266 43.1978 123.453 50.3737L123.465 50.4874C115.958 31.3687 103.228 23.6599 92.8319 6.87393C92.2949 6.01819 91.7735 5.15237 91.2678 4.27693C91.0072 3.81965 90.7632 3.35267 90.5364 2.87693C90.1052 2.0239 89.7729 1.12239 89.5462 0.19068C89.5465 0.147687 89.5313 0.106083 89.5035 0.0738066C89.4757 0.0415298 89.4372 0.0208387 89.3955 0.0156805C89.3545 0.00421329 89.3113 0.00421329 89.2704 0.0156805C89.2618 0.0156805 89.2481 0.0314305 89.2379 0.0349305C89.2276 0.0384305 89.2053 0.0541805 89.1899 0.0611805L89.2156 0.0156805C72.539 9.99068 66.8808 28.4567 66.36 37.6932C67.1343 37.6389 67.9017 37.5724 68.6932 37.5724C74.6104 37.5835 80.4192 39.1951 85.5289 42.2434C90.6387 45.2917 94.8671 49.668 97.7843 54.9272C93.1142 51.6227 87.4093 50.2076 81.7758 50.9564C105.656 63.1539 99.249 105.157 66.1544 103.572C63.2077 103.448 60.2957 102.874 57.5155 101.869C56.8657 101.621 56.2158 101.349 55.566 101.054C55.1909 100.879 54.8157 100.704 54.4457 100.508L54.4919 100.537C54.1699 100.38 53.8478 100.216 53.5258 100.046C53.8358 100.198 54.127 100.362 54.4457 100.508C46.3378 96.2272 39.6432 88.1352 38.8072 78.3107C38.8072 78.3107 41.8718 66.6434 60.7514 66.6434C62.7917 66.6434 68.6315 60.8247 68.736 59.1377C68.7103 58.5864 57.1557 53.8877 52.6504 49.3552C50.2435 46.9314 49.1009 45.7642 48.0885 44.8874C47.5414 44.414 46.9695 43.9712 46.3755 43.5609C44.8627 38.1516 44.7982 32.4267 46.1887 26.9832C40.0645 30.014 34.6226 34.3105 30.2076 39.6007H30.1768C27.5455 36.1934 27.7306 24.9584 27.8813 22.6117C27.1029 22.9313 26.3598 23.3343 25.6646 23.8139C23.3418 25.5075 21.1703 27.4078 19.1755 29.4927C16.9025 31.847 14.8264 34.3916 12.9691 37.0999V37.1104V37.0982C8.70062 43.2802 5.67306 50.2646 4.06125 57.6484L3.97217 58.0964C3.84711 58.6932 3.28694 61.7242 3.20643 62.3752C3.20643 62.4242 3.20643 62.3244 3.20643 62.3752C2.69407 65.5039 2.36686 68.6614 2.22656 71.8304V72.1804C2.24112 89.1629 8.49126 105.522 19.7417 118.025C30.9922 130.527 46.4244 138.263 62.9885 139.705C79.5525 141.146 96.0431 136.187 109.201 125.808C122.359 115.429 131.228 100.385 134.053 83.6499C134.164 82.7749 134.255 81.9087 134.355 81.0249C135.722 69.4788 134.242 57.7667 130.048 46.9542ZM123.461 50.4384L123.473 50.5102L123.461 50.4384Z",
    fill: "url(#paint11_linear_2092_5807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2092_5807",
    x1: 121.26,
    y1: 21.6877,
    x2: 8.77832,
    y2: 127.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.167 15.5384) scale(138.41 141.395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5908 73.3444) scale(138.41 141.395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.2781 -16.5496) scale(100.272 102.435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2817 110.278) scale(65.903 67.3242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.1548 61.7564) rotate(-13.8735) scale(34.9834 41.7396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.8441 9.75266) scale(47.4106 48.433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.11 -20.9669) scale(202.279 206.642)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.0611 -9.47709) rotate(84.1023) scale(151.418 97.3211)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7272 27.692) scale(126.287 129.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2092_5807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.0629 35.2432) scale(138.22 141.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2092_5807",
    x1: 119.936,
    y1: 21.1067,
    x2: 24.1522,
    y2: 114.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxLogo);
export default __webpack_public_path__ + "static/media/firefox_logo.54c4648f07741e12b95023b3e5687ea5.svg";
export { ForwardRef as ReactComponent };